<template>
  <div>
    <v-card>
      <v-tabs
        v-model="tab"
        align-with-title
        background-color="orange"
        grow
      >
        <v-tabs-slider color="red"></v-tabs-slider>

        <v-tab>Aligners</v-tab>
        <v-tab>Tru-Points</v-tab>
        <v-tab>Aligners-Oasis</v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <UpdateSchedulerAligners ref="aligners"/>
        </v-tab-item>
        <v-tab-item>
          <UpdateSchedulerGtps ref="gtps"/>
        </v-tab-item>
        <v-tab-item>
          <UpdateSchedulerAlignersOasis ref="oasis"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import UpdateSchedulerAligners from '../components/update_scheduler/UpdateSchedulerAligners.vue';
import UpdateSchedulerGtps from '../components/update_scheduler/UpdateSchedulerGtps.vue';
import UpdateSchedulerAlignersOasis from '../components/update_scheduler/UpdateSchedulerAlignersOasis.vue';

export default {
  components: {
    UpdateSchedulerAligners,
    UpdateSchedulerGtps,
    UpdateSchedulerAlignersOasis,
  },

  data() {
    return {
      tab: 0,
    };
  },

  methods: {
    refreshTab(tab) {
      if (this.$refs[tab]) {
        // this.$refs[tab].getData();
      }
    },
  },
};
</script>

<style scoped>
</style>
